// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"80":"@applet/cmp","153":"@applet/core","240":"@applet/APPLET_ID","630":"@applet/MEDAD_ILS"}[chunkId] || chunkId) + "." + {"80":"d664b334","153":"2bd8415e","240":"f4522463","307":"f0c6538b","630":"59c12c29"}[chunkId] + ".chunk.js";
};